// extracted by mini-css-extract-plugin
export default {"footer":"footer--No_Lw","footer_row":"footer_row--bN8p0","footer__panel":"footer__panel--M1pu_","footer__title":"footer__title--tOiSq","footer__content":"footer__content--ArqOB"};